import { render, staticRenderFns } from "./CreatePopper.vue?vue&type=template&id=5c142c5c"
import script from "./CreatePopper.vue?vue&type=script&lang=js"
export * from "./CreatePopper.vue?vue&type=script&lang=js"
import style0 from "./CreatePopper.vue?vue&type=style&index=0&id=5c142c5c&prod&lang=scss"
import style1 from "./CreatePopper.vue?vue&type=style&index=1&id=5c142c5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports